module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTIgOCI+CiAgICA8cGF0aCBmaWxsPSIjMDE1RDAzIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4xNDcgMEw1LjkxOSA0LjMxIDEuNzcyLjA3OCAwIDEuODg5IDUuOTk0IDggMTIgMS44OXoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-arrow-dark.svg
// module id = RNLl
// module chunks = 1